import React from "react";
import styled from "styled-components";

import {
  Grid,
  Hidden,
  List,
  ListItemText as MuiListItemText,
  ListItem as MuiListItem,
} from "@mui/material";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(1) / 4}px
    ${(props) => props.theme.spacing(4)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

const ListItem = styled(MuiListItem)`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};
  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

const HiddenHash = styled.span`
  color: ${(props) => props.theme.footer.background}!important;
  user-select: text;
  font-size: 0.75rem;
  margin-left: 4px;
`;

function Footer() {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Hidden mdDown>
          <Grid container item xs={12} md={6}>
            <List>
              <ListItem button={true} component="a" href="mailto:pedro@sherwood.science">
                <ListItemText primary="Support" />
              </ListItem>
              {/* <ListItem button={true} component="a" href="#">
                <ListItemText primary="Help Center" />
              </ListItem>
              <ListItem button={true} component="a" href="#">
                <ListItemText primary="Privacy" />
              </ListItem>
              <ListItem button={true} component="a" href="#">
                <ListItemText primary="Terms of Service" />
              </ListItem> */}
            </List>
          </Grid>
        </Hidden>
        <Grid container item xs={12} md={6} justifyContent="flex-end">
          <List>
            <ListItem>
              <ListItemText
                primary={
                  <>
                    {`© ${new Date().getFullYear()} - Sherwood Hospital v${__APP_VERSION__}`}
                    {/* __BUILD_TIME__ is intentionally rendered (hidden) so the
                        entry chunk's content hash rotates on every build, busting
                        the PWA service-worker precache on each deploy. Do NOT
                        remove it or move it behind a dead-code branch — see
                        docs/features/app-version-define.md. */}
                    <HiddenHash>{`${__GIT_HASH__} ${__BUILD_TIME__}`}</HiddenHash>
                  </>
                }
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
